import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import actions from "./actions";
const getTotalValues = (products, fields) => {
  const totalValues = {};
  const productsArray = Object.values(products).flat().filter(x => !x.isDefault);
  fields.forEach(field => {
    totalValues[field] = parseFloat(productsArray.reduce((accumulator, product) => {
      return accumulator + product.quantity * product[field];
    }, 0));
  });
  return totalValues;
};
export const setCurrentPage = payload => async function thunk(dispatch) {
  dispatch(actions.setCurrentPage.receive(payload));
};
export const setPrevPageTotal = payload => async function thunk(dispatch) {
  dispatch(actions.setPrevPageTotal.receive(payload));
};
export const setProductCatalog = payload => async function thunk(dispatch) {
  dispatch(actions.setProductCatalog.receive(payload));
};
export const setSectionCatalog = payload => async function thunk(dispatch) {
  dispatch(actions.setSectionCatalog.receive(payload));
};
export const setCrossSellProductsMiniCart = payload => async function thunk(dispatch) {
  dispatch(actions.setCrossSellProductsMiniCart.receive(payload));
};
export const setCrossSellProductsModalFirst = payload => async function thunk(dispatch) {
  dispatch(actions.setCrossSellProductsModalFirst.receive(payload));
};
export const setCrossSellProductsModalSecond = payload => async function thunk(dispatch) {
  dispatch(actions.setCrossSellProductsModalSecond.receive(payload));
};
export const setCrossSellProductsBeforeCartModalFirst = payload => async function thunk(dispatch) {
  dispatch(actions.setCrossSellProductsBeforeCartModalFirst.receive(payload));
};
export const setCrossSellProductsBeforeCartModalSecond = payload => async function thunk(dispatch) {
  dispatch(actions.setCrossSellProductsBeforeCartModalSecond.receive(payload));
};
export const setCatalogHash = payload => async function thunk(dispatch) {
  dispatch(actions.setCatalogHash.receive(payload));
};
export const setFilters = payload => async function thunk(dispatch) {
  const stickersFilter = payload.ls_dish_stickers;
  const correlatedFilters = Object.keys(stickersFilter.correlated_filters);
  const activeCorrelatedFilters = stickersFilter.values.filter(x => correlatedFilters.includes(x));
  const filterToDisable = Object.entries(stickersFilter.correlated_filters).filter(x => activeCorrelatedFilters.includes(x[0])).map(x => x[1]).flat();
  const newActiveFilters = stickersFilter.values.length > 0 ? stickersFilter.values.filter(x => !filterToDisable.includes(x)) : stickersFilter.disabled_filters;
  const payloadUpdated = _objectSpread(_objectSpread({}, payload), {}, {
    ls_dish_stickers: _objectSpread(_objectSpread({}, stickersFilter), {}, {
      values: [...newActiveFilters],
      disabled_filters: [...filterToDisable]
    })
  });
  dispatch(actions.setFilters.receive(payloadUpdated));
};
export const setMemberAttributeFilters = payload => async function thunk(dispatch, getState) {
  const {
    catalog
  } = getState();
  const newFilters = _objectSpread(_objectSpread({}, catalog.filters), {}, {
    member_attribute_availability: _objectSpread(_objectSpread({}, catalog.filters.member_attribute_availability), {}, {
      values: payload
    })
  });
  dispatch(actions.setFilters.receive(newFilters));
};
export const resetFilters = () => async function thunk(dispatch, getState) {
  const {
    catalog
  } = getState();
  const stickersFilter = catalog.filters.ls_dish_stickers;
  const payloadUpdated = _objectSpread(_objectSpread({}, catalog.filters), {}, {
    ls_dish_stickers: _objectSpread(_objectSpread({}, stickersFilter), {}, {
      values: [],
      disabled_filters: []
    })
  });
  dispatch(actions.setFilters.receive(payloadUpdated));
};
export const setFilterPanel = payload => async function thunk(dispatch) {
  dispatch(actions.setFilterPanel.receive(payload));
};
export const setCookingTimes = payload => async function thunk(dispatch) {
  dispatch(actions.setCookingTimes.receive(payload));
};
export const setLastModalOpenSetter = payload => async function thunk(dispatch) {
  dispatch(actions.setLastModalOpenSetter.receive(payload));
};
export const setMainMyoModalOpen = payload => async function thunk(dispatch) {
  dispatch(actions.setMainMyoModalOpen.receive(payload));
};
export const toggleFilterPanelOpen = () => async function thunk(dispatch, getState) {
  const {
    catalog
  } = getState();
  const filterPanel = catalog.filterPanel;
  const payload = _objectSpread(_objectSpread({}, filterPanel), {}, {
    isOpen: !filterPanel.isOpen
  });
  dispatch(actions.setFilterPanel.receive(payload));
};
export const setMyoSelection = payload => async function thunk(dispatch) {
  const calculatedFields = ["price", "ls_co2", "ls_carboidrati", "ls_zuccheri", "ls_grassi", "ls_grassi_saturi", "ls_proteine", "ls_fibre"];
  const totalValues = getTotalValues(payload.products, calculatedFields);
  const productsFlat = Object.values(payload.products).flat();
  const totalDiscount = productsFlat.reduce((accumulator, product) => {
    return accumulator + (parseFloat(product.discount) || 0);
  }, 0);
  const totalPriceDiscounted = parseFloat(totalValues.price) - totalDiscount;
  const enrichedTotalValues = _objectSpread({
    price_discounted: totalPriceDiscounted,
    discount: totalDiscount
  }, totalValues);
  const payloadUpdated = _objectSpread(_objectSpread(_objectSpread({}, payload), enrichedTotalValues), {}, {
    productsFlat: productsFlat
  });
  dispatch(actions.setMyoSelection.receive(payloadUpdated));
};
export const resetMyoSelection = () => async function thunk(dispatch) {
  const payload = {
    products: {},
    productsFlat: [],
    options: [],
    originalProduct: null,
    price: 0
  };
  dispatch(actions.setMyoSelection.receive(payload));
};
export const setOnlyItemAtPriceWhitelist = payload => async function thunk(dispatch) {
  dispatch(actions.setOnlyItemAtPriceWhitelist.receive(payload));
};